import {types} from './types';

const initialState = {
    data: {
        list: [],
        totalPage: 1
    },
    transaction: {
        list: [],
        totalPage: 1
    }
}

export function replenishmentTransactionReportReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_TRANSACTION_REPORT:
            return { ...state, transaction: action.payload};
        default:
            return state
    }
}